import { useMutation } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type { ErrorRequest, ApiError } from '../types/showcase';

/**
 * Mutation: POST /api/eraf/showcase/error
 * Always rejects (server intentionally throws 4xx/5xx).
 * The rejection ApiError IS the demo result — display it as a success card.
 */
export function useErrorDemo() {
  return useMutation<never, ApiError, ErrorRequest>({
    mutationFn: (req) => showcaseApi.simulateError(req),
    mutationKey: ['common-showcase', 'error'],
  });
}
